// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2dElS","tab":"Tabs_tab__2tb7u","tabActive":"Tabs_tabActive__IKQw5"};